<template>
  <data-table
    :headers="tableHeaders"
    :items="articles"
    :route="{ name: 'news-articles.manage', params: ['id'] }"
    disable-sort
    v-bind="$props"
    v-on="$listeners"
  >
    <template #header.translations>
      <v-tooltip top>
        <template #activator="{ on }">
          <v-icon small v-on="on">language</v-icon>
        </template>
        <span>Translations</span>
      </v-tooltip>
    </template>
    <template #item="{ item: article }">
      <td class="text-center">
        <flag-pip :flag="article.language.flag" :text="article.language.name" show-label class="mt-2" />
      </td>
      <td :title="article.headline">{{ truncate(article.headline, 60) }}</td>
      <td>
        <published-chip :value="article.wp_publish_status" small />
      </td>
      <td>
        <div v-if="article.published_at">
          <div>{{ formatDate(article.published_at) }}</div>
          <div class="text-caption">{{ formatTime(article.published_at) }}</div>
        </div>
        <span v-else>-</span>
      </td>
      <td v-if="!compact" class="text-caption">
        {{ getOptionKeyByValue(siteGroups, article.site.site_group_id) }}
      </td>
      <td v-if="!compact" class="text-center">{{ article.newsArticles.length }}</td>
    </template>
    <template #actions="{ item: article }">
      <v-list-item v-if="showArticleFilter" @click="onShowTranslationsClick(article.news_article_id)">
        <v-list-item-title>
          <v-icon left small>language</v-icon>
          <span>Show translations</span>
        </v-list-item-title>
      </v-list-item>
      <v-list-item :disabled="!article.wp_permalink" @click="openInNewTab(article.wp_permalink)">
        <v-list-item-title>
          <v-icon left small>launch</v-icon>
          <span>Preview in new tab</span>
        </v-list-item-title>
      </v-list-item>
    </template>
  </data-table>
</template>

<script>
// Helpers
import { mapGetters } from 'vuex'
import { truncate } from '@/utils/string'
import { formatDate, formatTime } from '@/utils/date'
import getOptionKeyByValue from '@/utils/get-option-key-by-value'
// Components
import { VDataTable } from 'vuetify/lib'
import DataTable from '@/components/data-table'
import FlagPip from '@/views/news-articles/components/flag-pip'
import PublishedChip from '@/views/news-articles/components/published-chip'

export default {
  name: 'NewsArticleTable',
  components: {
    DataTable,
    FlagPip,
    PublishedChip,
  },
  extends: VDataTable,
  props: {
    articles: {
      type: Array,
      default: () => [],
    },
    compact: {
      type: Boolean,
      default: false,
    },
    showArticleFilter: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters({ siteGroups: 'siteGroups/getSiteGroupOptions' }),
    tableHeaders() {
      return [
        { text: 'Language', value: 'language', align: 'center' },
        { text: 'Headline', value: 'headline', width: '280' },
        { text: 'Status', value: 'status' },
        { text: 'Publish Date', value: 'published' },
        !this.compact ? { text: 'Site Group', value: 'sitegroup' } : null,
        !this.compact ? { text: '', value: 'translations', align: 'center' } : null,
        { value: 'actions' },
      ].filter(Boolean)
    },
  },
  methods: {
    formatDate,
    formatTime,
    getOptionKeyByValue,
    truncate,
    openInNewTab(url) {
      window.open(url, '_blank').focus()
    },
    onShowTranslationsClick(newsArticleId) {
      this.$emit('filter-by-id', newsArticleId)
    },
  },
}
</script>
<style lang="scss" scoped>
.pointer {
  cursor: pointer;
}
</style>
